module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "credits"
    }
  }, [_c('div', {
    staticClass: "credits-container-top-gradient"
  }), _vm._v(" "), _c('div', {
    staticClass: "credits-scrollable-container"
  }, [_c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v("Crédits")])]), _vm._v(" "), _c('div', {
    staticClass: "row content-container"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-1"
  }, [_c('div', {
    staticClass: "desc-container"
  }, [_c('h3', [_vm._v("Un projet collaboratif")]), _vm._v(" "), _c('q', [_vm._v("\n            La Plateforme Ouverte des Parcours d'imaginaires (la POP) propose une édition numérique collaborative de l'Anthologie Palatine (AP) dirigée par la "), _c('a', {
    attrs: {
      "href": "https://ecrituresnumeriques.ca/fr/Objets-de-recherche/"
    }
  }, [_vm._v("Chaire en Recherche du Canada sur les écritures numériques")]), _vm._v(" (CRC) et son équipe interdisciplinaire et internationale (dirigée par Marcello Vitali-Rosati) en collaboration avec Elsa Bouchard et l'équipe d'HETIC. L’Anthologie Palatine est un recueil d’épigrammes grecques dont la source remonte à l’époque hellénistique (323-30 av. J.-C) qui a dès lors exercé une influence majeure sur la littérature, de la Renaissance jusqu’à nos jours. La POP propose une visualisation des versions grecques des épigrammes de l'AP et ses traductions, leurs métadonnées (auteur, date, lieu et mots-clefs) sous la forme de parcours de lecture thématiques. L'usager est invité à collaborer à cette édition en proposant directement sur la plateforme "), _c('a', {
    attrs: {
      "href": "https://anthologia.ecrituresnumeriques.ca/home"
    }
  }, [_vm._v("Anthologia")]), _vm._v(" des liens faibles, soit en associant à l’épigramme une référence (textuelle, iconographique, musicale, cinématographique ou autre) qui témoigne de l’imaginaire collectif suggéré par l’épigramme et vient ainsi ainsi enrichir le matériel anthologique.\n\n             Sur la POP sont disponibles les versions grecques des épigrammes de l'AP et ses traductions (en français, anglais et italien), leurs métadonnées (auteur, date, lieu et mots-clefs) sous la forme de parcours de lecture thématiques. L'usager est invité à collaborer à cette édition en proposant des liens faibles, soit en associant à l’épigramme une référence (textuelle, iconographique, musicale, cinématographique ou autre) qui témoigne de l’imaginaire collectif suggéré par l’épigramme et vient ainsi ainsi enrichir le matériel anthologique. Ce projet invite donc à une appropriation d’un objet littéraire insaisissable soit à comprendre et associer l’AP avec nos propres chimères intérieures.\n\n            "), _c('br'), _c('br'), _vm._v("Pour plus d’informations, consultez le "), _c('a', {
    attrs: {
      "href": "http://anthologia-doc.ecrituresnumeriques.ca/fr_FR/"
    }
  }, [_vm._v("site web")]), _vm._v(" du projet.\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-1"
  }, [_c('div', {
    staticClass: "team-container"
  }, [_c('h4', [_c('span', {
    staticClass: "bg"
  }), _vm._v("Équipe Université de Montréal "), _c('sup')]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Marcello Vitali-Rosati")]), _vm._v(" "), _c('li', [_vm._v("Elsa Bouchard")]), _vm._v(" "), _c('li', [_vm._v("Margot Mellet")]), _vm._v(" "), _c('li', [_vm._v("Arthur Juchereau")]), _vm._v(" "), _c('li', [_vm._v("Servanne Monjour")]), _vm._v(" "), _c('li', [_vm._v("Louis-Olivier Brassard")]), _vm._v(" "), _c('li', [_vm._v("Enrico Agostini-Marchese")])]), _vm._v(" "), _c('h4', [_c('span', {
    staticClass: "bg"
  }), _vm._v("Équipe HETIC "), _c('sup')]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/milenatarriere",
      "target": "_blank"
    }
  }, [_vm._v("Miléna Tarrière : Chef de Projet"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://nahelmoussi.com/",
      "target": "_blank"
    }
  }, [_vm._v("Nahel Moussi : UX/UI Designer site web"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://raphaelaupee.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Raphaël Aupée : Développeur Back"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://paulchagnon.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Paul Chagnon : UX/UI Designer documentation et back office"), _c('span', {
    staticClass: "dash"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://valentin-crochemore.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Valentin Crochemore : Développeur Front"), _c('span', {
    staticClass: "dash"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 col-md-offset-1"
  }, [_c('div', {
    staticClass: "page-subtitle-container"
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v(" "), _c('h2', [_vm._v("L’Université de"), _c('br'), _vm._v(" Montréal & HETIC.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "credits-container-bottom-gradient"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f3d75b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreditsComponent.vue
// module id = 92
// module chunks = 0